import * as React from 'react';
import { Checkbox } from 'react-bootstrap';
import { Field, formValueSelector, change, reduxForm, WrappedFieldMetaProps, WrappedFieldInputProps } from 'redux-form';
import { flow, noop } from 'lodash';
import FieldFormControl from '../../../../components/FieldFormControl/index';
import { connect } from 'react-redux';
import { IQuoteState } from '../../../../services/quote/models';
import { IStore } from '../../../../redux/IStore';
import {IChannel} from '../../../../data/api/models';

interface IMarketingOptionsProps {
  quote: IQuoteState;
  channel: IChannel;
  dispatch: any;
  marketingEmail: number;
  marketingPhone: number;
  marketingSms: number;
  marketingPost: number;
}

interface IMarketingOptionsState {
  isSelectedAll: boolean;
}

class MarketingOptions extends React.Component<IMarketingOptionsProps, IMarketingOptionsState> {
  public state = {
    isSelectedAll: false,
  };

  public componentDidMount() {
    const { dispatch, marketingEmail, marketingPhone, marketingSms, marketingPost } = this.props;

    if (marketingEmail > 0 && marketingPhone > 0 && marketingSms > 0 && marketingPost > 0) {
      dispatch(change('quote', 'selectAll', true));
      this.setState({ isSelectedAll: true });
    } else {
      dispatch(change('quote', 'selectAll', false));
      this.setState({ isSelectedAll: false });
    }
  }

  public componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props;

    if (nextProps.marketingEmail > 0 && nextProps.marketingPhone > 0 && nextProps.marketingSms > 0
      && nextProps.marketingPost > 0) {
      dispatch(change('quote', 'selectAll', true));
      this.setState({ isSelectedAll: true });
    } else {
      dispatch(change('quote', 'selectAll', false));
      this.setState({ isSelectedAll: false });
    }
  }

  private toggleSelectAll = () => {
    const { dispatch } = this.props;
    const { isSelectedAll } = this.state;
    if (isSelectedAll === false) {

      this.setState({
        isSelectedAll: true,
      });

      dispatch(change('quote', 'travellers[0].marketingOptions.email', 1));
      dispatch(change('quote', 'travellers[0].marketingOptions.phone', 1));
      dispatch(change('quote', 'travellers[0].marketingOptions.sms', 1));
      dispatch(change('quote', 'travellers[0].marketingOptions.post', 1));
    }

    if (isSelectedAll === true) {

      this.setState({
        isSelectedAll: false,
      });

      dispatch(change('quote', 'travellers[0].marketingOptions.email', -1));
      dispatch(change('quote', 'travellers[0].marketingOptions.phone', -1));
      dispatch(change('quote', 'travellers[0].marketingOptions.sms', -1));
      dispatch(change('quote', 'travellers[0].marketingOptions.post', -1));
    }
  }

  private handleCheckboxConsent = (input: WrappedFieldInputProps) => (event: any) => {
    const { dispatch } = this.props;

    dispatch(change('quote', input.name, this.valueToInt(input)));
  }

  private valueToInt(input: WrappedFieldInputProps) {
    if (input.value === 'true' || input.value === 1 || input.value === 2) {
      return -1;
    }

    return 1;
  }

  private valueToBool(input: WrappedFieldInputProps) {
    return input.value === 1 || input.value === 2;
  }

  private renderMarketingConsentCheckbox = (
    { input, meta, children, ...props }:
      { input: WrappedFieldInputProps, meta: WrappedFieldMetaProps, children: any },
  ) => {

    return (
      <Checkbox
        type="checkbox"
        name={input.name}
        onChange={this.handleCheckboxConsent(input)}
        checked={this.valueToBool(input)}
        onBlur={noop}
        value={-1}
        children={children}
      />
    );
  }

  public render() {
    const { channel } = this.props;
    return (
      <div className="getting-back-quotes-box">
        {channel.key !== 'camc-b2c' && (
            channel.key !== 'tpl-b2c' ? (
                <>
                    <p>
                        We may from time to time contact you by email or other electronic means to provide you with
                        information in relation to special offers, services and events which may be of interest to you.
                    </p>
                    <p>
                        Please select how you'd prefer to be contacted, or leave blank if you prefer NOT to receive such
                        information.
                    </p>
                </>
            ) : (
                <>
                    <p>
                        We would like to keep in touch with you about special offers, products, services and events
                        which may be of interest to you. We never sell your data and we won’t bombard your inbox! You
                        can opt out at any time.
                    </p>
                    <p>
                        Please tell us how you prefer us contact you or leave blank if you prefer NOT to receive such
                        information.
                    </p>
                </>
            )
        )}
        <div>
          {channel.key !== 'camc-b2c' && (
            <div>
              <Field
                  name="selectAll"
                  type="checkbox"
                  component={FieldFormControl}
                  value={true}
                  onChange={this.toggleSelectAll}
              >
                <span className="select-all">
                  {this.state.isSelectedAll ? 'Unselect all' : 'Select all'}
                </span>
                <div/>
              </Field>
            </div>
          )}
          <div className="">
            {channel.key !== 'camc-b2c' ? (
                <Field
                    name="travellers[0].marketingOptions.email"
                    type="checkbox"
                    value={1}
                    component={this.renderMarketingConsentCheckbox}
                >
                  email
                  <div/>
                </Field>
            ) : (
                <Field
                    name="travellers[0].marketingOptions.email"
                    type="checkbox"
                    value={1}
                    component={this.renderMarketingConsentCheckbox}
                >
                  Email
                  <div/>
                </Field>
            )}
            {channel.key !== 'camc-b2c' && (
                <Field
                    name="travellers[0].marketingOptions.phone"
                    type="checkbox"
                    value={1}
                    component={this.renderMarketingConsentCheckbox}
                >
                  phone
                  <div/>
                </Field>
            )}
            {channel.key !== 'camc-b2c' && (
                <Field
                    name="travellers[0].marketingOptions.sms"
                    type="checkbox"
                    value={1}
                    component={this.renderMarketingConsentCheckbox}
                >
                  text
                  <div/>
                </Field>
            )}
            {channel.key !== 'camc-b2c' && (
                <Field
                    name="travellers[0].marketingOptions.post"
                    type="checkbox"
                    value={1}
                    component={this.renderMarketingConsentCheckbox}
                >
                  post
                  <div/>
                </Field>
            )}
          </div>
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const marketingEmail = selector(state, 'travellers[0].marketingOptions.email');
      const marketingPhone = selector(state, 'travellers[0].marketingOptions.phone');
      const marketingSms = selector(state, 'travellers[0].marketingOptions.sms');
      const marketingPost = selector(state, 'travellers[0].marketingOptions.post');

      return {
        marketingEmail,
        marketingPhone,
        marketingSms,
        marketingPost,
        quote: state.quote,
        channel: state.branding.channel,
      };
    },
  ),
])(MarketingOptions);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/MarketingOptions/index.tsx